import React, { useState, useEffect } from "react"
import { useMediaQuery } from "react-responsive"
import { TABLET_WIDTH, NAVIGATION_LINKS } from "../../constants/common"
import HeaderMenu from "../../components/icons/HeaderMenu"
import ArrowRight from "../../components/icons/ArrowRight"
import { Link, useNavigate } from "react-router-dom"
import NewsoftLogo from "../../assets/images/logo_newsoft.svg"
import "./index.scss"
import { DESKTOP_NAVIGATION } from "../../data/header/desktop_navigation"

import {
    TeamAugmentationRoute,
    TryNowRoute,
    QuarkworksRoute,
    HelloRoute,
    PednetRoute,
    CraftRoute,
    OrbitRoute,
    ITConsultingAndAdvisoryRoute,
} from "../../routes"
import { GetInTouch } from "../../utils"

const Header = () => {
    const isTablet = useMediaQuery({ minWidth: TABLET_WIDTH })
    const [isHovered, setIsHovered] = useState(false)
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [scrollDirection, setScrollDirection] = useState(null)
    const navigate = useNavigate()
    const AboutUsHeader = "About us"

    useEffect(() => {
        const handleMouseMove = (event) => {
            if (event.clientY < 70 && window.scrollY > 2)  {
                setScrollDirection(true)
            }
        }
    
        window.addEventListener("mousemove", handleMouseMove)
    
        return () => {
            window.removeEventListener(
                "mousemove",
                handleMouseMove
            )
        }
    }, [])

    const [openSections, setOpenSections] = useState({
        aboutUs: false,
        services: false,
        cases: false,
    })

    const handleToggleMenu = () => {
        if (isTablet) {
            setIsMenuOpen(false)
        }
        else {
            setIsMenuOpen(!isMenuOpen)
        }

        if (isMenuOpen) {
            setOpenSections({
                aboutUs: false,
                services: false,
                cases: false,
            })
        }
    }

    const toggleHover = (section="") => {
        if (section !== AboutUsHeader) {
            setIsHovered((prevState) => !prevState)
        }
    }

    const navigateTo = (section) => {
        if (section == AboutUsHeader) {
            handleNavOptionClick()
            setIsHovered(false)
            navigate(NAVIGATION_LINKS.ABOUT_US)
        }
    }

    const handleToggleSection = (section) => {
        setOpenSections((prevOpenSections) => ({
            ...prevOpenSections,
            [section]: !prevOpenSections[section],
        }))
    }

    useEffect(() => {
        let lastScrollY = window.scrollY

        const updateScrollDirection = () => {
            const scrollY = window.scrollY
            const direction = scrollY > lastScrollY ? false : true
            if (
                direction !== scrollDirection &&
                (scrollY - lastScrollY > 1 || scrollY - lastScrollY < -1)
            ) {
                if (isMenuOpen) {
                    handleToggleMenu()
                }
                setScrollDirection(direction)
            }
            lastScrollY = scrollY > 0 ? scrollY : 0
        }
        
        window.addEventListener("scroll", updateScrollDirection)
        return () => {
            window.removeEventListener("scroll", updateScrollDirection)
        }
    }, [scrollDirection])

    function handleNavOptionClick() {
        toggleHover()
        handleToggleMenu()
    }


    window.onscroll = function() {
        if (this.scrollY < 5) {  //2
            setScrollDirection(null)
        }
    }


    return (
        <div className={`header ${scrollDirection || scrollDirection == null ? "show" : "hide" }`} >
            <div className="header-navigation">
                {!isTablet && (
                    <>
                        <Link
                            to="/"
                            target="_parent"
                            className="header-navigation-logo t-ns"
                        >
                            Newsoft
                        </Link>
                        <div className="header-navigation-mobile">
                            <HeaderMenu
                                width={30}
                                height={30}
                                onClick={handleToggleMenu}
                                isOpen={isMenuOpen}
                            />
                        </div>
                    </>
                )}
                {isTablet && (
                    <>
                        {isHovered ? (
                            <div className="header-navigation-logo">
                                <img src={NewsoftLogo} alt="Newsoft logo"></img>
                            </div>
                        ) : (
                            <Link
                                to="/"
                                target="_parent"
                                className="header-navigation-logo t-ns"
                            >
                                Newsoft
                            </Link>
                        )}
                        <div className="header-navigation-desktop">
                            {DESKTOP_NAVIGATION.map((el, id) => (
                                <div
                                    key={id}
                                    className="header-navigation-desktop-items"
                                    onMouseEnter={() => toggleHover(el.header)}
                                    onMouseLeave={() => toggleHover(el.header)}
                                >
                                    {el.section && <hr />}
                                    <p className="header-navigation-desktop-items-title" onClick={() => navigateTo(el.header)}>
                                        {el.header}
                                    </p>
                                    {el.section && isHovered && (
                                        <div className="header-navigation-desktop-items-subitems">
                                            <div
                                                className={`header-navigation-desktop-items-subitems-container ${el.section}`}
                                            >
                                                {el.items.map((i, id) => (
                                                    <div
                                                        key={id}
                                                        className={`header-navigation-desktop-items-subitems-container-subitem ${el.section}`}
                                                    >
                                                        <hr className="divider" />
                                                        <div>
                                                            <Link to={i.link} onClick={handleNavOptionClick} className="title t-s3" >
                                                                {i.title}
                                                            </Link>
                                                            <a className="t-b4">
                                                                {i.text}
                                                            </a>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                            <a onClick={() => GetInTouch()} className="header-menu-link">
                                get in touch
                                <ArrowRight width={26} color={"white"} />
                            </a>
                        </div>
                    </>
                )}
            </div>
            {scrollDirection || isMenuOpen  ? <hr className="border-up"/> : <></>}
            {isMenuOpen && !isTablet && (
                <div className="header-menu">
                    <div className="header-menu-list">
                        <div
                            className={`header-menu-list-item${
                                openSections.aboutUs ? "-active" : ""
                            }`}
                        >
                            <p
                                className="t-s5"
                                onClick={() => navigateTo(AboutUsHeader)}
                            >
                                About us
                            </p>
                        </div>

                        <div
                            className={`header-menu-list-item${
                                openSections.services ? "-active" : ""
                            }`}
                        >
                            <p
                                className="t-s5"
                                onClick={() => handleToggleSection("services")}
                            >
                                Services
                            </p>
                            <ul className="header-menu-list-item-horizontally">
                                <Link to={TeamAugmentationRoute.path}
                                    onClick={handleNavOptionClick}
                                >
                                    Team Augmentation
                                </Link>
                                <Link to={ITConsultingAndAdvisoryRoute.path}
                                    onClick={handleNavOptionClick}
                                >
                                    IT Consulting & Advisory
                                </Link>
                            </ul>
                        </div>

                        <div
                            className={`header-menu-list-item${
                                openSections.cases ? "-active" : ""
                            }`}
                        >
                            <p
                                className="t-s5"
                                onClick={() => handleToggleSection("cases")}
                            >
                                Cases
                            </p>
                            <ul>
                                <Link to={TryNowRoute.path} onClick={handleNavOptionClick} >
                                    TryNow
                                </Link>
                                <Link to={HelloRoute.path} onClick={handleNavOptionClick} >
                                    Hello
                                </Link>
                                <Link to={QuarkworksRoute.path} onClick={handleNavOptionClick} >
                                    Quarkworks
                                </Link>
                                <Link to={CraftRoute.path} onClick={handleNavOptionClick} >
                                    Craft
                                </Link>
                                <Link to={OrbitRoute.path} onClick={handleNavOptionClick} >
                                    Orbit
                                </Link>
                                <Link to={PednetRoute.path} onClick={handleNavOptionClick} >
                                    PedNet
                                </Link>
                            </ul>
                        </div>
                    </div>
                    <a onClick={() => GetInTouch()} className="header-menu-link t-nav">
                        get in touch
                        <ArrowRight width={26} color={"white"} />
                    </a>
                </div>
            )}
            {isMenuOpen && isTablet && <div></div>}
        </div>
    )
}

export default Header
